import {
    CLOSE_DELETE_DIALOG,
    DISABLE_WAITING,
    ENABLE_WAITING,
    OPEN_DELETE_DIALOG,
    UPDATE_DELETE_DIALOG,
} from "@/core/store/modules/generic/constants";
import Vue from 'vue'

export default {
    [OPEN_DELETE_DIALOG](state, args) {
        state.deleteDialog = args
        state.deleteDialog.status = true
    },
    [UPDATE_DELETE_DIALOG](state, args) {
        state.deleteDialog.x = args.x
        state.deleteDialog.y = args.y
    },
    [CLOSE_DELETE_DIALOG](state) {
        state.deleteDialog = {
            status: false
        }

    },
    [ENABLE_WAITING](state, action) {
        Vue.set(state.waiting, action, true);
    },
    [DISABLE_WAITING](state, action) {
        Vue.set(state.waiting, action, false);
    }
}